/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusAnforderungDetailDto } from '../../models/lexplus-anforderung-detail-dto';

export interface AnforderungDetailControllerGetAnforderungDetailV1$Params {
  anforderungsversionID: number;
}

export function anforderungDetailControllerGetAnforderungDetailV1(http: HttpClient, rootUrl: string, params: AnforderungDetailControllerGetAnforderungDetailV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusAnforderungDetailDto>> {
  const rb = new RequestBuilder(rootUrl, anforderungDetailControllerGetAnforderungDetailV1.PATH, 'get');
  if (params) {
    rb.path('anforderungsversionID', params.anforderungsversionID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusAnforderungDetailDto>;
    })
  );
}

anforderungDetailControllerGetAnforderungDetailV1.PATH = '/v1/compliance/anforderungen/{anforderungsversionID}';
